import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { ROLE_LABELS } from "@/lib/nav";
import { Sun, Moon } from "lucide-react";

export default function SettingsPage() {
  const { user } = useAuth();
  const { theme, toggle } = useTheme();

  return (
    <div className="space-y-5 fade-up max-w-3xl" data-testid="settings-page">
      <div><h1 className="text-3xl font-bold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Personalize your Senrize Medical Flow experience</p></div>

      <Card>
        <CardHeader><CardTitle>Profile</CardTitle></CardHeader>
        <CardContent>
          <div className="flex items-center gap-4">
            <Avatar className="size-16">
              <AvatarFallback className="bg-primary text-primary-foreground text-xl font-bold">{user.name?.slice(0,2).toUpperCase()}</AvatarFallback>
            </Avatar>
            <div>
              <div className="font-semibold text-lg">{user.name}</div>
              <div className="text-sm text-muted-foreground">{user.email}</div>
              <div className="text-xs text-muted-foreground mt-1">{ROLE_LABELS[user.role]}</div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Appearance</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-base">Theme</Label>
              <div className="text-sm text-muted-foreground">Toggle between light and dark mode.</div>
            </div>
            <Button variant="outline" onClick={toggle} className="gap-2" data-testid="theme-toggle-btn">
              {theme === "dark" ? <Sun className="size-4" /> : <Moon className="size-4" />}
              {theme === "dark" ? "Light" : "Dark"} mode
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Clinic information</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label>Clinic</Label><Input value="Senrize Medical Flow" readOnly /></div>
          <div className="space-y-1.5"><Label>Branch</Label><Input value="Downtown" readOnly /></div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Notifications</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          {[
            "Appointment reminders",
            "Lab results ready",
            "Payment overdue",
            "Follow-up reminders",
          ].map((label) => (
            <div key={label} className="flex items-center justify-between">
              <Label className="font-normal">{label}</Label>
              <Switch defaultChecked />
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
